const React = require("react");
const T = React.PropTypes;

const CauditData = require("../../types/metadata/CauditData.js");
const CauditActionCreators = require("../../actionCreators/metadata/CauditActionCreators.js");

const HttpResponse = require("../HttpResponse.jsx");
const Spinner = require("../Spinner.jsx");

const styles = {
    Question: {
        display: "inline-block",
        marginRight: "2em"
    },
    Choices: {
        marginLeft: "1em",
        display: "inline-block",
        width: "auto"
    },
    Note: {
        display: "block",
        padding: ".5em .1em 0 0"
    }
};

function byFacilityNumberAscending(fac1, fac2) {
    if (fac1.facilityNumber > fac2.facilityNumber) return 1;

    if (fac1.facilityNumber < fac2.facilityNumber) return -1;

    return 0;
}

function byAuditPeriodDescending(period1, period2) {
    if (period1.auditPeriod > period2.auditPeriod) return -1;

    if (period1.auditPeriod < period2.auditPeriod) return 1;

    return 0;
}

function byAuditNameAscending(audit1, audit2) {
    if (audit1.auditName > audit2.auditName) return 1;

    if (audit1.auditName < audit2.auditName) return -1;

    return 0;
}

const CauditForm = React.createClass({
    propTypes: CauditData.Type.isRequired,
    componentDidMount() {
        if (!this.props.Targets.Loaded
            && !this.props.Targets.Loading) {
            CauditActionCreators.LoadTargets();
        }
    },
    componentWillReceiveProps(next) {
        if (!this.props.Targets.Loaded
            && next.Targets.Loaded) {
            const update = this.GetDefaultsFromTargets(next.Targets.Data);

            this.setState(update);
        }
    },
    getInitialState() {
        if (this.props.Targets.Loaded) {
            const result = this.GetDefaultsFromTargets(this.props.Targets.Data);

            return result;
        }

        return {
            SelectedStore: null,
            SelectedAuditPeriod: null,
            SelectedAuditID: null
        };
    },
    render() {
        const isLoading = this.props.Targets.Loading;
        const error = this.props.Targets.Error;

        const hasError = error !== null;

        if (hasError) {
            const details = error.response
                ? (<HttpResponse Response={error.response } />)
                : error.Message;

            return (
                <div>
                    <h4>Audit list loading failed.</h4>
                    <h5>
                        Please give it another try by reloading the page.  If you continue to get this error, kindly contact support with the message below.
                    </h5>
                    {details}
                </div>);
        }

        if (isLoading
            || !this.props.Targets.Data.length) {
            return (<div>
                <Spinner style={{ padding: 0 }} Message="Loading eligible audits..." WithTimer={true} Large={true} />
            </div>);
        }

        const storeOptions = this.props.Targets.Data
            .sort(byFacilityNumberAscending)
            .map(this.GetStoreOption);

        const periodOptions = this.state.SelectedStore.auditPeriods
            .sort(byAuditPeriodDescending)
            .map(this.GetPeriodOption);

        const auditOptions = this.state.SelectedAuditPeriod.audits
            .sort(byAuditNameAscending)
            .map(this.GetAuditOption);

        return (<div>
            <div style={styles.Question}>
                <label htmlFor="pickStore">
                    Store
                </label>
                <select id="pickStore" className="form-control" style={styles.Choices}
                        onChange={this.StoreChanged}
                        value={this.state.SelectedStore.facilityNumber}>
                    {storeOptions}
                </select>
            </div>
            <div style={styles.Question}>
                <label htmlFor="pickAudit">
                    Audit Period
                </label>
                <select id="pickPeriod" className="form-control" style={styles.Choices}
                        onChange={this.PeriodChanged}
                        value={this.state.SelectedAuditPeriod.auditPeriod}>
                    {periodOptions}
                </select>
            </div>
            <div style={styles.Question}>
                <label htmlFor="pickAudit">
                    Audit Type
                </label>
                <select id="pickAudit" className="form-control" style={styles.Choices}
                        onChange={this.TargetChanged}
                        value={this.state.SelectedAuditID}>
                    <option value="">Please select an audit</option>
                    {auditOptions}
                </select>
            </div>
            <div style={styles.Note}>
                NOTE: If you don't see your audit here, please be
                sure that it exists in the SmartAudit system first.
            </div>
        </div>);
    },
    GetStoreOption(store, i) {
        return (<option key={i} value={store.facilityNumber }>
            {store.facilityNumber}
        </option>);
    },
    GetPeriodOption(period, i) {
        return (<option key={i} value={period.auditPeriod }>
            {period.auditPeriod}
        </option>);
    },
    GetAuditOption(audit, i) {
        return (<option key={i} value={audit.auditID }>
            {audit.auditName}
        </option>);
    },
    GetDefaultsFromTargets(data) {
        const firstStore = data.sort(byFacilityNumberAscending)[0];
        const firstPeriod = firstStore.auditPeriods.sort(byAuditPeriodDescending)[0];
        const firstAudit = firstPeriod.audits.sort(byAuditNameAscending)[0];

        return {
            SelectedStore: firstStore,
            SelectedAuditPeriod: firstPeriod,
            SelectedAuditID: ""
        };
    },
    StoreChanged(e) {
        if (e.target.value) {
            const store = this.props.Targets.Data.find(
                s => s.facilityNumber === e.target.value);

            this.setState({
                SelectedStore: store,
                SelectedAuditPeriod: store.auditPeriods[0],
                SelectedAuditID: ""
            });

            CauditActionCreators.SelectTarget(store.auditPeriods[0].audits[0].auditID);
        }
    },
    PeriodChanged(e) {
        if (e.target.value) {
            const period = this.state.SelectedStore.auditPeriods.find(
                p => p.auditPeriod === e.target.value);

            this.setState({
                SelectedAuditPeriod: period,
                SelectedAuditID: ""
            });

            CauditActionCreators.SelectTarget(period.audits[0].auditID);
        }
    },
    TargetChanged(e) {
        this.setState({
            SelectedAuditID: e.target.value
        });

        CauditActionCreators.SelectTarget(e.target.value);
    }
});

module.exports = CauditForm;


// WEBPACK FOOTER //
// ./src/components/metadata/CauditForm.jsx